/* Quiz taglie Kylea — popup a 4 passi, calcolo taglia e applicazione alla buybox */
(function () {
  'use strict';

  function fill(tpl, map) {
    var out = String(tpl || '');
    Object.keys(map || {}).forEach(function (k) {
      out = out.split('[' + k + ']').join(map[k] == null ? '' : String(map[k]));
    });
    return out;
  }

  function parseJson(str, fallback) {
    try { return JSON.parse(str); } catch (e) { return fallback; }
  }

  function init(root) {
    if (root.__kyQuizInit) return;
    root.__kyQuizInit = true;

    var sizes = parseJson(root.dataset.sizes, []).slice().sort(function (a, b) { return a.s - b.s; });
    if (!sizes.length) return;
    var cmMap = parseJson(root.dataset.cm, {});
    var minEu = parseInt(root.dataset.min, 10) || 34;
    var maxEu = parseInt(root.dataset.max, 10) || 47;
    var storeKey = 'ky-quiz-size:' + root.id;
    /* 'same': un numero dispari va nella taglia doppia che lo contiene (39 → 38-39); 'up': si arrotonda in su */
    var oddSame = root.dataset.odd === 'same';
    var apparel = root.dataset.kind === 'apparel';

    var stepsPanel = root.querySelector('.ky-quiz__panel-steps');
    var resultPanel = root.querySelector('.ky-quiz__panel-result');
    var backBtn = root.querySelector('.ky-quiz__back');
    var dots = root.querySelectorAll('.ky-quiz__dot');
    var etaEl = root.querySelector('[data-ky-eta]');
    var q2El = root.querySelector('[data-ky-q2]');
    var q3El = root.querySelector('[data-ky-q3]');
    var q2Tpl = root.dataset.q2 || '';
    var q3Tpl = root.dataset.q3 || '';
    var resultEl = root.querySelector('[data-ky-result]');
    var confEl = root.querySelector('[data-ky-confidence]');
    var continueBtn = root.querySelector('[data-ky-continue]');
    var continueTextEl = root.querySelector('[data-ky-continue-text]');
    var retakeBtn = root.querySelector('[data-ky-retake]');
    var guideBtn = root.querySelector('[data-ky-guide]');
    var section = root.closest('.shopify-section') || document;

    var brandBtns = root.querySelectorAll('.ky-quiz__opt[data-brand]');
    var sizeBtns = root.querySelectorAll('.ky-quiz__size-btn');
    var fitBtns = root.querySelectorAll('[data-fit]');
    var widthBtns = root.querySelectorAll('[data-width]');
    var measuresBox = root.querySelector('[data-ky-measures-box]');
    var measuresEl = root.querySelector('[data-ky-measures]');
    var measuresSizeEl = root.querySelector('[data-ky-measures-size]');
    var tabs = root.querySelectorAll('.ky-quiz__tab');

    var state = {
      step: 1, brand: '', brandOffset: 0, brandKnown: false,
      eu: null, idx: null, usual: '', fit: '', fitPhrase: '', width: '', widthPhrase: '',
      size: null, naturalSize: null, confidence: 0, oor: 0, unit: 'size'
    };

    /* ── Calcolo ─────────────────────────────────────────────── */
    function clamp(n, a, b) { return Math.max(a, Math.min(b, n)); }

    function pairFor(eu) {
      var start = (eu % 2 === 0 || oddSame) ? eu : eu + 1;
      var best = null, bestD = Infinity;
      sizes.forEach(function (z) {
        var d = (start >= z.s && start <= z.e) ? 0 : Math.min(Math.abs(start - z.s), Math.abs(start - z.e));
        if (d < bestD || (d === bestD && best && z.s > best.s)) { best = z; bestD = d; }
      });
      return best;
    }

    function computeApparel() {
      var last = sizes.length - 1;
      var adj = 0;
      if (state.fit === 'stretta') adj += 1;
      if (state.width === 'largo') adj += 1;
      if (state.width === 'aderente' && state.fit === 'larga') adj -= 1;
      adj = clamp(adj, -1, 1);
      var raw = (state.idx || 0) + adj;
      state.oor = raw > last ? 1 : (raw < 0 ? -1 : 0);
      state.size = sizes[clamp(raw, 0, last)];
      state.naturalSize = ((state.idx || 0) > last || (state.idx || 0) < 0) ? { v: state.usual, s: state.idx, e: state.idx } : sizes[clamp(state.idx || 0, 0, last)];
      var c = 86;
      if (state.fit === 'perfetta') c += 4;
      if (state.width === 'comodo') c += 3;
      if (state.fit === 'stretta' || state.fit === 'larga') c += 2;
      if (Math.abs(adj) >= 1) c += 1;
      state.confidence = Math.min(96, c);
    }

    function compute() {
      if (apparel) { computeApparel(); return; }
      var base = state.brandOffset;
      var adj = base;
      if (state.fit === 'stretta') adj += 1;
      if (state.fit === 'larga') adj -= 1;
      if (state.width === 'molto-largo') adj += 1;
      if (state.width === 'stretto' && state.fit === 'larga') adj = Math.max(adj, base - 1);
      adj = clamp(adj, -1, 2);

      /* Fuori dalle taglie che il prodotto ha davvero: lo diciamo, non arrotondiamo e basta */
      var raw = (state.eu || minEu) + adj;
      var minServed = sizes[0].s - 1;
      var maxServed = sizes[sizes.length - 1].e;
      state.oor = raw > maxServed ? 1 : (raw < minServed ? -1 : 0);

      var eu = clamp(raw, minServed, maxServed);
      state.size = pairFor(eu);
      state.naturalSize = pairFor(clamp(state.eu || minEu, minServed, maxServed));

      var c = 86;
      if (state.fit === 'perfetta') c += 4;
      if (state.width === 'normale') c += 3;
      if (state.fit === 'stretta' || state.fit === 'larga') c += 2;
      if (Math.abs(adj) >= 1) c += 1;
      if (state.brandKnown) c += 2;
      state.confidence = Math.min(96, c);
    }

    function label(unit) {
      if (!state.size) return '—';
      if (unit === 'cm') return cmMap[state.size.v] || state.size.v;
      return state.size.v;
    }

    /* ── Render ──────────────────────────────────────────────── */
    function renderQuestions() {
      if (q2El) q2El.textContent = fill(q2Tpl, { marca: state.brand });
      if (q3El) q3El.textContent = fill(q3Tpl, { marca: state.brand });
    }

    function renderResult() {
      compute();
      // Senza lunghezza in cm per questa taglia (es. taglie bambino) la scheda cm non serve
      var hasCm = !!(state.size && cmMap[state.size.v]);
      if (!hasCm) state.unit = 'size';
      tabs.forEach(function (t) { if (t.dataset.unit === 'cm') t.hidden = !hasCm; });
      if (resultEl) resultEl.textContent = label(state.unit);
      if (confEl) confEl.textContent = state.confidence + '%';
      if (continueTextEl) continueTextEl.textContent = fill(root.dataset.continue, { taglia: state.size ? state.size.v : '' });

      var r1 = root.querySelector('[data-ky-reason="1"]');
      var r2 = root.querySelector('[data-ky-reason="2"]');
      var r3 = root.querySelector('[data-ky-reason="3"]');
      var box = root.querySelector('.ky-quiz__result-box');
      if (box) box.classList.toggle('is-oor', !!state.oor);
      [r2, r3].forEach(function (el) {
        var li = el && el.closest('li');
        if (li) li.hidden = !!state.oor;
      });

      var numero = apparel ? state.usual : state.eu;
      if (measuresBox) {
        var m = state.size ? cmMap[state.size.v] : '';
        measuresBox.hidden = !m;
        if (measuresEl) measuresEl.textContent = m || '';
        if (measuresSizeEl) measuresSizeEl.textContent = state.size ? state.size.v : '';
      }
      if (state.oor) {
        var oorTpl = state.oor > 0 ? root.getAttribute('data-oor-high') : root.getAttribute('data-oor-low');
        if (r1) r1.textContent = fill(oorTpl, { taglia: state.size ? state.size.v : '', numero: numero });
      } else {
        if (r1) r1.textContent = fill(root.getAttribute('data-reason-1'), { marca: state.brand, numero: numero });
        if (r2) r2.textContent = state.fitPhrase;
        if (r3) {
          var tpl = root.dataset.reasonSame;
          if (state.size && state.naturalSize && state.size.s > state.naturalSize.s) tpl = root.dataset.reasonUp;
          else if (state.size && state.naturalSize && state.size.s < state.naturalSize.s) tpl = root.dataset.reasonDown;
          r3.textContent = fill(tpl, {
            taglia: state.size ? state.size.v : '',
            numero: numero,
            larghezza: state.widthPhrase
          });
        }
      }
      tabs.forEach(function (t) { t.classList.toggle('is-selected', t.dataset.unit === state.unit); });
    }

    function showStep(n) {
      state.step = n;
      root.querySelectorAll('.ky-quiz__step').forEach(function (s) {
        var on = parseInt(s.dataset.step, 10) === n;
        s.hidden = !on;
      });
      dots.forEach(function (d) {
        var num = parseInt(d.dataset.step, 10);
        d.classList.remove('is-active', 'is-done');
        if (num < n) d.classList.add('is-done');
        if (num === n) d.classList.add('is-active');
      });
      if (backBtn) { if (n === 1) backBtn.setAttribute('hidden', ''); else backBtn.removeAttribute('hidden'); }
      if (etaEl) {
        var totalSteps = dots.length || 1;
        var secs = Math.max(5, Math.round(60 * (totalSteps - n + 1) / totalSteps / 5) * 5);
        etaEl.textContent = fill(n >= totalSteps ? root.dataset.etaLast : root.dataset.eta, { secondi: secs });
      }
      if (stepsPanel) stepsPanel.hidden = false;
      if (resultPanel) resultPanel.hidden = true;
      renderQuestions();
    }

    function showResult() {
      state.unit = 'size';
      if (stepsPanel) stepsPanel.hidden = true;
      if (resultPanel) resultPanel.hidden = false;
      renderResult();
    }

    function clearSelection(list) {
      list.forEach(function (b) { b.classList.remove('is-selected'); });
    }

    function reset() {
      state.step = 1; state.brand = ''; state.brandOffset = 0; state.brandKnown = false;
      state.eu = null; state.idx = null; state.usual = ''; state.fit = ''; state.fitPhrase = ''; state.width = ''; state.widthPhrase = '';
      state.size = null; state.naturalSize = null; state.oor = 0; state.unit = 'size';
      [brandBtns, sizeBtns, fitBtns, widthBtns].forEach(function (l) { clearSelection(Array.prototype.slice.call(l)); });
      tabs.forEach(function (t) { t.classList.toggle('is-selected', t.dataset.unit === 'size'); });
      showStep(1);
    }

    /* ── Apertura / chiusura ─────────────────────────────────── */
    function open() {
      reset();
      root.classList.remove('is-in');
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ky-quiz-locked');
      void root.offsetWidth;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { root.classList.add('is-in'); });
      });
    }

    function close() {
      root.classList.remove('is-in');
      setTimeout(function () {
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('ky-quiz-locked');
      }, 350);
    }

    root.__kyQuizOpen = open;
    root.__kyQuizClose = close;

    /* ── Applicazione della taglia alla buybox ───────────────── */
    var lastApplied = null;

    function setSelect(sel, value) {
      var ok = Array.prototype.some.call(sel.options, function (o) { return o.value === value; });
      if (!ok || sel.value === value) return ok;
      sel.value = value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    function applyToTiers(value) {
      var done = false;
      document.querySelectorAll('[data-ky-tiers] select[data-ky-field="size"]').forEach(function (sel) {
        if (setSelect(sel, value)) done = true;
      });
      return done;
    }

    function applySize(value) {
      if (!value) return;
      lastApplied = value;
      applyToTiers(value);
      var radios = section.querySelectorAll('input[type="radio"][name^="option"]');
      Array.prototype.forEach.call(radios, function (input) {
        if (input.value === value && !input.checked && !input.disabled) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      var selects = section.querySelectorAll('select[name^="option"]');
      Array.prototype.forEach.call(selects, function (sel) { setSelect(sel, value); });
    }

    /* Gli scaglioni ridisegnano le righe quando cambi scaglione o colore:
       rimettiamo la taglia consigliata sulle righe appena create. */
    document.addEventListener('click', function (e) {
      if (!lastApplied) return;
      if (e.target.closest('select')) return;
      if (!e.target.closest('[data-ky-tier]') && !e.target.closest('[data-ky-swatch]')) return;
      setTimeout(function () { applyToTiers(lastApplied); }, 40);
    });

    function updateCtas(value) {
      var tpl = value ? root.dataset.ctaDone : root.dataset.ctaText;
      var text = fill(tpl, { taglia: value || '' });
      document.querySelectorAll('[data-ky-quiz-open="' + root.id + '"]').forEach(function (cta) {
        var el = cta.querySelector('.ky-quiz-cta__text');
        if (el) el.textContent = text;
        cta.classList.toggle('is-done', !!value);
      });
      try {
        if (value) sessionStorage.setItem(storeKey, value);
        else sessionStorage.removeItem(storeKey);
      } catch (e) {}
    }

    function restoreCta() {
      try {
        var saved = sessionStorage.getItem(storeKey);
        // La chiave e' la stessa su tutti i prodotti: si ripristina solo una taglia che questo prodotto ha
        if (saved && sizes.some(function (z) { return z.v === saved; })) updateCtas(saved);
      } catch (e) {}
    }

    /* ── Eventi ──────────────────────────────────────────────── */
    brandBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        clearSelection(Array.prototype.slice.call(brandBtns));
        b.classList.add('is-selected');
        state.brand = b.dataset.brand || '';
        state.brandOffset = parseInt(b.dataset.offset, 10) || 0;
        state.brandKnown = !/^altr/i.test(state.brand);
        renderQuestions();
        setTimeout(function () { showStep(2); }, 180);
      });
    });

    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        clearSelection(Array.prototype.slice.call(sizeBtns));
        b.classList.add('is-selected');
        if (apparel) {
          state.idx = parseInt(b.dataset.idx, 10) || 0;
          state.usual = b.textContent.trim();
          setTimeout(function () { showStep(2); }, 180);
          return;
        }
        state.eu = parseInt(b.dataset.eu, 10);
        setTimeout(function () { showStep(3); }, 180);
      });
    });

    fitBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        clearSelection(Array.prototype.slice.call(fitBtns));
        b.classList.add('is-selected');
        state.fit = b.dataset.fit || '';
        state.fitPhrase = b.dataset.phrase || '';
        setTimeout(function () { showStep(apparel ? 3 : 4); }, 180);
      });
    });

    widthBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        clearSelection(Array.prototype.slice.call(widthBtns));
        b.classList.add('is-selected');
        state.width = b.dataset.width || '';
        state.widthPhrase = b.dataset.phrase || '';
        setTimeout(showResult, 180);
      });
    });

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { state.unit = t.dataset.unit; renderResult(); });
    });

    if (backBtn) backBtn.addEventListener('click', function () { if (state.step > 1) showStep(state.step - 1); });

    root.querySelectorAll('[data-ky-quiz-close]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); close(); });
      if (el.getAttribute('role') === 'button') {
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); close(); }
        });
      }
    });

    if (retakeBtn) retakeBtn.addEventListener('click', reset);

    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        var value = state.size ? state.size.v : null;
        applySize(value);
        updateCtas(value);
        // Altre pagine (es. Mix & Match) mettono la taglia dove serve a loro
        if (value) root.dispatchEvent(new CustomEvent('ky:quiz-size', { bubbles: true, detail: { value: value } }));
        close();
      });
    }

    if (guideBtn) {
      guideBtn.addEventListener('click', function () {
        close();
        var ids = [root.dataset.guideDrawer, root.dataset.guidePopover];
        setTimeout(function () {
          for (var i = 0; i < ids.length; i++) {
            if (!ids[i]) continue;
            var toggle = document.querySelector('[aria-controls="' + ids[i] + '"]');
            if (toggle && toggle.offsetParent !== null) { toggle.click(); return; }
          }
        }, 380);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    showStep(1);
    restoreCta();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-ky-quiz-open]');
    if (!trigger) return;
    e.preventDefault();
    var root = document.getElementById(trigger.getAttribute('data-ky-quiz-open'));
    if (!root) return;
    if (!root.__kyQuizInit) init(root);
    if (root.__kyQuizOpen) root.__kyQuizOpen();
  });

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ky-quiz]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();